// ------------------------------------
// Constants
// ------------------------------------
export const SERVICE_GET_REQUEST = "SERVICE_GET_REQUEST";
export const SERVICE_GET_REQUEST_SUCCESS = "SERVICE_GET_REQUEST_SUCCESS";
export const SERVICE_GET_REQUEST_FAILURE = "SERVICE_GET_REQUEST_FAILURE";
export const SERVICE_GET_RESET = "SERVICE_GET_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(id) {
  return {
    type: SERVICE_GET_REQUEST,
    id,
  };
}

export function requestSuccess(data, id) {
  return {
    type: SERVICE_GET_REQUEST_SUCCESS,
    data,
    id,
  };
}

export function requestFailure(error, id) {
  return {
    type: SERVICE_GET_REQUEST_FAILURE,
    error,
    id,
  };
}

export function reset() {
  return {
    type: SERVICE_GET_RESET,
  };
}
